import { render, staticRenderFns } from "./Cookies.vue?vue&type=template&id=3034950f&scoped=true&lang=html"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034950f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3034950f')) {
      api.createRecord('3034950f', component.options)
    } else {
      api.reload('3034950f', component.options)
    }
    module.hot.accept("./Cookies.vue?vue&type=template&id=3034950f&scoped=true&lang=html", function () {
      api.rerender('3034950f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookies.vue"
export default component.exports